import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'
import Button from '../Button'

export default class SwitcherOption extends PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  }

  static defaultProps = {
    onClick: noop,
  }

  handleClick = e => {
    const { onClick, value } = this.props
    e.preventDefault()
    onClick(value)
  }

  render() {
    const { label, description, isCurrent } = this.props
    const innerContent = (
      <>
        <div className="switcher-option__title">
          {label}
          {isCurrent && <span className="current-indicator">✔</span>}
        </div>
        <div className="switcher-option__description">{description}</div>
      </>
    )
    let content
    if (isCurrent) {
      content = <div>{innerContent}</div>
    } else {
      content = (
        <Button type="button" className="button-reset switcher-option__button" onClick={this.handleClick}>
          {innerContent}
        </Button>
      )
    }
    return <li className="switcher-option">{content}</li>
  }
}
